<template>
    <div class="container">
        <div class="top-card">
            <h4 class="topic"></h4>
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                    <div class="card" style="width: 100%;height: 150px;background-color: rgba(75,208,255,0.69)">
                        <div class="card-body" style="text-align: center;margin:auto;">

                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                    <div class="card" style="width: 100%;height: 150px;background-color: #f7ff00">
                        <div class="card-body" style="text-align: center">

                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                    <div class="card" style="width: 100%;height: 150px;background-color: rgba(255,128,0,0.56)">
                        <div class="card-body" style="text-align: center">

                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 py-lg-0 py-1">
                    <div class="card" style="width: 100%;height: 150px;background-color: #cccccc">
                        <div class="card-body" style="text-align: center">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container second-part">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="card" style="background-color: #cccccc;">
                    <div class="card-body" style="text-align: center">

                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12 py-lg-0 py-3">
                <div class="card" style="background-color: #cccccc;">
                    <div class="card-body" style="text-align: center;">

                    </div>
                </div>
            </div>
        </div>
        <div class="row py-lg-3 py-1">
            <div class="col-lg-6 col-md-12">
                <div class="card" style="background-color: #cccccc;">
                    <div class="card-body" style="text-align: center">

                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 py-lg-0 py-3">
                <div class="card" style="background-color: #cccccc;">
                    <div class="card-body" style="text-align: center">

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MainPageLoadingView"
}
</script>

<style scoped>

.topic{
    width: 200px;
    height: 30px;
    display: block;
    background: #eee linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%) 0 0;
    border-radius: 5px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
}

.top-card .row{
    align-items: center;
    text-align: center;
}
.top-card .card{
    cursor: pointer;
    background: #4bcfff linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%) 0 0;
    border-radius: 5px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
}

.second-part .card{
    height: 400px;
    background: #eee linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%) 0 0;
    border-radius: 5px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
}


@keyframes shine {
    to {
        background-position-x: -200%;
    }
}


</style>
